import type { TypedUseQuerySubscriptionOptions } from '@reduxjs/toolkit/query/react';
import FlexeserveDeviceAPI from '../FlexeserveDevice/FlexeserveDeviceAPI';

type Options = TypedUseQuerySubscriptionOptions;
interface Params {
  storeId: string;
  deviceId: string;
  options?: Options;
}
function useGetDeviceFromStoreByParam(params: Params) {
  const { storeId, deviceId, options } = params;
  const responseDevicesAPI = FlexeserveDeviceAPI.useGetStoreDevicesQuery(
    storeId,
    options
  );

  const { data: devicesAPI, ...rest } = responseDevicesAPI;

  return {
    ...rest,
    data: devicesAPI?.find((device) => device.uuid === deviceId),
  };
}

export default useGetDeviceFromStoreByParam;
